<template>
    <transition
    name="unpin-slide"
    @after-leave="afterLeave"
  >
    <div v-if="!isLeaving" class="info-card" :class="{ expanded: expanded.notes, collapsed: !expanded.notes }">
        <div class="info-card-content">
        <div v-if="!expanded.notes">
          <div class="info-row">
            <div class="icon-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none">
                  <path d="M2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H14C14.55 0 15.0208 0.195833 15.4125 0.5875C15.8042 0.979167 16 1.45 16 2V18C16 18.55 15.8042 19.0208 15.4125 19.4125C15.0208 19.8042 14.55 20 14 20H2ZM2 18H14V2H12V9L9.5 7.5L7 9V2H2V18Z" fill="#25B8C2"/>
                </svg>
            </div>
            <p class="info-text-title">Encounter Notes:</p>
        </div>
        </div>
            <div v-else class="info-card-content-col-group">
                <div class="info-row">
                    <div class="icon-container">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none">
                        <path d="M2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H14C14.55 0 15.0208 0.195833 15.4125 0.5875C15.8042 0.979167 16 1.45 16 2V18C16 18.55 15.8042 19.0208 15.4125 19.4125C15.0208 19.8042 14.55 20 14 20H2ZM2 18H14V2H12V9L9.5 7.5L7 9V2H2V18Z" fill="#25B8C2"/>
                      </svg>
                    </div>
                </div>
                <div>
                  <div>
                    <p class="info-text-title">Encounter Notes:</p>
                    <p class="info-text mb-2 mt-1">{{ notesData.notes }}</p>
                    <p class="info-text-medication-info-text">{{ notesData.date }}</p>
                  </div>
              </div>
            </div>
            <div v-if="expanded.notes" class="action-icons">
              <div v-if="!isCardPinned" class="action-icon" @click.stop="handlePinCard">
                <img src="@/assets/cardActions/pin.svg" alt="Unpin" />
              </div>
              <div v-if="isCardPinned" class="action-icon" @click.stop="startUnpin">
                <img src="@/assets/cardActions/unpin.svg" alt="Pin" />
              </div>
              <div v-if="showFooter" class="action-icon" @click.stop="toggleCard('notes')">
                <img src="@/assets/cardActions/collapse.svg" alt="Expand" />
              </div>
            </div>
            <div v-else class="flex flex-row items-center gap-2">
              <div @click.stop="toggleCard('notes')" class="action-icon">
                <img src="@/assets/cardActions/expand.svg" alt="Collapse" />
              </div>
              <div class="drag-handle action-icon">
                <img src="@/assets/cardActions/move.svg" alt="Move" />
              </div>
            </div>
          </div>
          <div class="card-expand" :class="{ 'justify-end': !showFooter, 'justify-between': showFooter }">
            <FoldableButton v-if="showFooter" customized_class="drag-handle" text="Move">
              <template #prefix>
                <img src="@/assets/cardActions/move.svg" alt="Move" />
              </template>
            </FoldableButton>
          <div class="flex flex-row gap-1 justify-end">
            <FoldableButton text="View">
              <template #prefix>
                <img src="@/assets/cardActions/view.svg" alt="View" />
              </template>
            </FoldableButton>
            <FoldableButton text="Resend">
              <template #prefix>
                <img src="@/assets/cardActions/resend.svg" alt="Resend" />
              </template>
            </FoldableButton>
          </div>
        </div>
    </div>
    </transition>
  </template>
  <script setup>
  import { ref, computed } from 'vue'
  import { useMyPatientsStore } from '@/store/helpers'
  import { useCardActions } from '@/composables/useCardActions'
  
  // Define props
  const props = defineProps({
    patient: {
      type: String,
      default: ''
    },
    cardData: {
      type: Object,
      default: () => ({})
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    context: {
      type: String,
      default: 'pegboard'
    }
  })
  
  // Define emits
  const emit = defineEmits(['pin-card', 'unpin-card'])
  
  const { patientInfoStore } = useMyPatientsStore()
  
  // Use the card actions composable
  const { isCardPinned, handlePinCard, handleUnpinCard } = useCardActions(props, emit)
  
  const isLeaving = ref(false);
  
  
  const startUnpin = () => {
    if(props.showFooter){
      isLeaving.value = true; // triggers the leave animation
    } else {
      handleUnpinCard()
    }
  };
  
  
  // This is called after the leave animation finishes
  const afterLeave = () => {
    emit('unpin-card', props.cardData); // parent removes the card
  };
  
  
  const expanded = ref({
    notes: true,
  })
  
  const toggleCard = (cardType) => {
    expanded.value[cardType] = !expanded.value[cardType]
  }
  
  import { getCurrentPatientId } from '@/utils/patientUtils';
  
  // Get notes data from store
  const notesData = computed(() => {
    return patientInfoStore.getters.getNotesCardData(props.patient) || {
      notes: 'N/A',
      date: 'N/A'
    }
  })
  
  
  
  </script>
  
  
  <style scoped>
  .info-text-medication-info-text {
    color: var(--SecondaryBlack, #666);
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px; /* 140% */
  letter-spacing: 0.1px;
  }
  
  /* Expanded card footer visibility with hover expand animation */
  .card-expand {
    display: flex;
    align-items: center;
    gap: 16px;
    /* animation base state */
    max-height: 0;
    overflow: hidden;
    opacity: 0;
    padding-top: 0;
    margin-top: 0;
    border-top: 1px dashed var(--DividerGray, #C4C4C4);
    border-top-color: transparent;
    pointer-events: none;
    transition: max-height 300ms linear,
                opacity 300ms linear,
                padding-top 300ms linear,
                margin-top 300ms linear,
                border-top-color 300ms linear;
  }
  
  .info-card.expanded:hover .card-expand {
    /* ensure enough room for actions */
    max-height: 80px;
    opacity: 1;
    padding-top: 10px;
    margin-top: 10px;
    border-top-color: var(--DividerGray, #C4C4C4);
    pointer-events: auto;
  }
  
  .pin-toggle {
    position: relative;
    cursor: pointer;
  }
  
  .pin-toggle .icon {
    position: absolute;
    transition: opacity 0.3s ease, transform 0.3s ease;
  }
  
  .pin-toggle .unpin {
    opacity: 0;
    transform: scale(0.8);
  }
  
  /* Hover effect */
  .pin-toggle:hover .pin {
    opacity: 0;
    transform: scale(1);
  }
  
  .pin-toggle:hover .unpin {
    opacity: 1;
    transform: scale(1);
  }
  
  
  .unpin-slide-leave-active {
    transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), 
                opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }
  
  .unpin-slide-leave-to {
    transform: translateX(-100%) scale(0.95);
    opacity: 0;
  }
  
  .peg-board-title {
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    font-size: 22px;
    color: #ffffff;
    text-align: center;
    margin-bottom: 16px;
  }
  
  .peg-board-content {
    display: flex;
    flex-direction: column;
    gap: 6px;
    overflow-y: auto;
    padding: 0 8px;
  }
  
  .info-card {
    background-color: white;
    border-radius: 5px;
    padding: 12px 16px;
    box-shadow: 0px 1px 25px 0px rgba(74, 74, 74, 0.15);
  }
  
  .info-card-content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
  }
  
  .info-card-content-col-group {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 8px;
  }
  
  .info-row-group {
    display: flex;
    flex-direction: column;
    gap: 10px;
    flex-grow: 1;
  }
  
  .info-row {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .icon-container {
    background-color: #f2f2f2;
    border-radius: 4px;
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .icon-style {
    width: 20px;
    height: 20px;
  }
  
  .info-text {
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    color: #333333;
    letter-spacing: 0.25px;
    line-height: 20px;
  }
  
  .action-icons {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  
  .action-icon {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
  
  .appointment-date {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 50px;
    height: 64px;
    border-radius: 5px;
    background-color: #ffffff;
    box-shadow: 0px 1px 15px 0px rgba(74, 74, 74, 0.1);
    overflow: hidden;
  }
  
  .month {
    background-color: #004879;
    color: white;
    width: 100%;
    text-align: center;
    padding: 2px 0;
    font-size: 14px;
  }
  
  .day {
    color: rgba(0, 0, 0, 0.65);
    text-align: center;
    font-family: Lato;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 120% */
    text-transform: capitalize;
    height: 24px;
  }
  
  .weekday {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.65);
    line-height: 1;
    padding-bottom: 3px;
  }
  
  .appointment-details {
      flex-grow: 1;
  }
  
  .detail-title {
      font-size: 12px;
      color: #666;
  }
  .detail-text {
      font-size: 14px;
      color: #333;
      margin-bottom: 4px;
  }
  .action-icons-appointment {
      display: flex;
      flex-direction: column;
      gap: 4px;
      padding-top: 20px;
  }
  .info-text-title {
      font-family: 'Inter', sans-serif;
      font-size: 12px;
      color: #666;
  }
  .info-text-large {
      font-family: 'Inter', sans-serif;
      font-size: 16px;
      color: #333;
      font-weight: 500;
  }
  
  /* Badge for billing preference */
  .badge {
    color: #25B8C2;
    font-family: Inter;
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 12px; /* 120% */
    letter-spacing: 0.25px;
    display: flex;
    padding: 4px 8px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
  }
  
  .badge-default {
    border-radius: 20px;
    background: #EBFFF8;
    width: 68px;
  }
  
  .expand-action {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #1B79A0;
    cursor: pointer;
    padding: 4px 10px;
    border-radius: 5px;
  }
  
  .expand-action span {
    color: var(--color-Darkblue-000, #1E4670);
    text-align: center;
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
  }
  
  
  .action-icon {
    width: 28px;          /* w-7 */
    height: 28px;         /* h-7 */
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;   /* rounded-[5px] */
    padding: 5px;         /* pd-5 (assuming you meant padding) */
    cursor: pointer;
    transition: background-color 0.2s; /* duration-200 transition-colors */
  }
  
  .action-icon:hover,
  .expand-action:hover {
    background-color: #E5F1FB; /* hover:bg-[#E5F1FB] */
  }
  </style>
  